import { render } from "./QuestionComp.vue?vue&type=template&id=e30dad24"
import script from "./QuestionComp.vue?vue&type=script&lang=js"
export * from "./QuestionComp.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3643421092/src/customer-feedback/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__